export function videoEmbed(url) {
	const vimeoRegex = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
	const youtubeRegex = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;

	if (vimeoRegex.test(url)) {
		const embed = '<iframe width="420" height="345" src="//player.vimeo.com/video/$1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
		return url.replace(vimeoRegex, embed);
	}

	if (youtubeRegex.test(url)) {
		const embed = '<iframe width="420" height="345" src="//www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>';
		return url.replace(youtubeRegex, embed);
	}
	return `<a href="${url}" target="_blank">${url}</a>`;
}

export default videoEmbed;